var validatePass = (rule, value, callback) => {
  let phone = /^(13|14|15|16|17|18|19)[0-9]\d{8}$/;
  if (value === "") {
    callback(new Error("请填写手机号码"));
  } else {
    if (!phone.test(value)) {
      callback([new Error("请输入正确的手机号")]);
    }
    callback();
  }
};
var validateEmail = (rule, value, callback) => {
  var re = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
  if (value === "") {
    callback(new Error("请填写邮箱"));
  } else {
    if (!re.test(value)) {
      callback([new Error("请输入正确的邮箱格式")]);
    }
    callback();
  }
};
var validateSfzh = (rule, value, callback) => {
  var sf = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value === "") {
    callback(new Error("请输入身份证号码"));
  } else if (!sf.test(value)) {
    callback(new Error("请输入正确的身份证号码"));
  } else {
    callback();
  }
};


var utils = {
    money:180,
    year:2021,
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    },
    formDate:{
        name: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        gender:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        cardid: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        password: {
            'repassword': '密码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        repassword: {
            'repassword': '确认密码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
       
        nation:{
            'name':'民族','value':'',option:'nation','showSelect':true,'select':
            ['汉族','蒙古族','回族','藏族','维吾尔族','彝族','壮族','布依族','朝鲜族','傣族',
            '德昂族','满族','侗族','瑶族','白族','土家族','哈尼族','景颇族', '哈萨克族','黎族',
            '傈僳族','畲族','高山族','拉祜族','水族','东乡族','纳西族','柯尔克孜族','土族','达斡尔族',
            '仫佬族','羌族','布朗族', '撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族',
            '怒族','乌孜别克族','俄罗斯族','鄂温克族','塔塔尔族','独龙族', '鄂伦春族','赫哲族','门巴族', '珞巴族',
            '基诺族','保安族','京族','佤族','裕固族','苗族'],
        },
        birthday: {
            'name':'出生日期','value':'','placeholder':'请填写，如：考试年月',option:'time','showSelect':false
        },
        company:{
            'name':'工作单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        post:{
            'name':'岗位及职务','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        education:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        phone:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },


      
        MEDUSPEC:{
            'name':'专业','value':'',option:'education','showSelect':true,'select':['中药学','药学','相关专业'],
        },
        sort: {
            'name':'证书类型','value':'',option:'certificate','showSelect':true,'select':['执业药师','从业药师'],
        },
        ExtentOne:{
            'name':'执业类别','value':'',option:'operation','showSelect':true,'select':['药学','中药学'],
        },
        QualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        
        zQualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        zATTEYEAR: {
            'name':'中药证书批准时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        NATIVEPLACE: {
            'name': '属地（市）','value':'','placeholder':'请填写','option':'userName','showSelect':true,'select':[
                '哈尔滨','齐齐哈尔','牡丹江','佳木斯','大庆','伊春','黑河','鸡西','鹤岗','双鸭山','七台河','绥化','大兴安岭','其它']
        },
        ExtentTwo:{
            'name':'执业范围','value':'',option:'operatorScope','showSelect':true,'select':
            ['生产','经营(批发)','经营(单体)','经营(连锁)','研发','使用','检验'],
        },
       
       
        MEDUSCHOOL:{
            'name':'毕业学校','value':'','placeholder':'请填写',option:'school','showSelect':false
        },
        MEDUTIME:{
            'name':'毕业时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        zxsj:{
            'name':'注销时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        rdnf:{
            'name':'认定年份','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        technicOne:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        JOBLEVEL:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','助理级','员级'],
        },
        WorkStat:{
            'name':'从事岗位','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        address:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        postalcode:{
            'name':'邮政编码','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        LINKPHONE:{
            'name':'单位电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        email:{
            'name':'E-mail','value':'','placeholder':'请填写',option:'email','showSelect':false
        },
        grjl:{
            'name':'个人简历','value':'','placeholder':'请填写',option:'email','showSelect':false,typpe:'textarea'
        },
        byzpic:{
            'name':'毕业证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zgzpic:{
            'name':'资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zzmm:{
            'name':'政治面貌','value':'','placeholder':'请填写',option:'email','showSelect':true,'select':['党',
        '团','民','群']
        },
        zcdw:{
            'name':'注册单位','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        zzzbh:{
            'name':'注册证号','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        REGISTERTIME: {
            'name':'注销时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
      
      },
    validatePass,
  validateEmail,
  validateSfzh,
      changefocus(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        if(isAndroid){
          setTimeout(function() {
           document.activeElement.scrollIntoViewIfNeeded();
           document.activeElement.scrollIntoView();
          }, 500);       
        }
    },
    changeBlur(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if(isIOS){
          setTimeout(() => {
            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 200)
        }
    },
   IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            return false
        } else if(isEdge) {
            return false//edge
        } else if(isIE11) {
            return true; //IE11  
        }else{
            return true;//不是ie浏览器
        }
    },
      enrollStr (str) {
        let str2 = ''
        if (str === 'face') {
            str2 = '函授'
        } else if (str === 'online') {
            str2 = '网络'
        } else if (str === 'repair') {
            str2 = '补修'
        }
        return str2
      },
      clear () {
      },
      token: {
        set (token) {
              window.localStorage.setItem("token", token);
          },
          get () {
              return window.localStorage.getItem('token');
          },
        remove () {
          window.localStorage.removeItem('token')
        }
      },
      news: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("newsIndex", str);
        },
        get () {
          return window.localStorage.getItem('newsIndex');
        },
        setList (str) {
            window.localStorage.setItem("Keyword", str);
        },
        getList () {
            return   window.localStorage.getItem("Keyword");
        }
      },
      userName: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("userName", str);
        },
        get () {
          return window.localStorage.getItem('userName');
        },
      },
      courseId: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("courseNum", str);
        },
        get () {
          return window.localStorage.getItem('courseNum');
        },
      },
      enroll: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("enrollName", str);
        },
        get () {
          return window.localStorage.getItem('enrollName');
        },
      },
      info: {
        set (str) { // 获取详细的新闻
         window.localStorage.setItem("info", str);
        },
        get () {
         return window.localStorage.getItem('info');
        }, 
      },
      quwstions2020:[
      ]
    }
    export default utils
    


// WEBPACK FOOTER //
// ./src/utils/index.js